export function tournamentTrackLabel(trackId, family) {
  const [division, participation] = String(trackId || "unspecified").split(":");
  const names = { unspecified: "Unspecified division", open: "Open division", metallic: "Metallic division", limited: "Limited division", practical: "Practical division", precision: "Precision division" };
  const name = names[division] || division.replace(/(^|[ _-])\w/g, value => value.toUpperCase());
  return family === "bullseye" ? `${name} / ${participation === "22only" ? ".22 only" : "Open aggregate"}` : name;
}

export function compareTournamentTracks(left, right) {
  const priority = value => {
    const [division, participation] = String(value).split(":");
    return (participation === "22only" ? 10 : 0) + (division === "open" ? 0 : 1);
  };
  return priority(left) - priority(right) || String(left).localeCompare(String(right));
}

export function tournamentResultReason(reason) {
  return ({ notApproved: "Not approved", noncountingMatch: "Not included in scoring", wrongDiscipline: "Different discipline",
    sourceNotAllowed: "Source type not enabled", structureUnavailable: "Course structure unavailable", structureMismatch: "Different course structure",
    missingMembership: "Match not attached", duplicateMembership: "Duplicate membership", missingSourceIdentity: "Source match unavailable",
    wrongSourceMatch: "Source mismatch", conflictingResultRevision: "Conflicting result versions", missingResultIdentity: "Result identity unavailable",
    participantOutcome: "Participant outcome excludes this result", noncountingEntry: "Not the counting entry", incomplete: "Incomplete result",
    unconfirmed: "Not confirmed", invalidScore: "Score unavailable", identityNeedsReview: "Identity needs review",
    participationNeedsReview: "Participation needs review", ambiguousCountingResult: "Multiple counting results need review",
  })[reason] || "Needs director review";
}

export function tournamentSourceReason(source, structureDiagnostics = []) {
  if (source.reason !== "structureUnavailable") return tournamentResultReason(source.reason);
  const issue = structureDiagnostics.find(item => item.eventLinkId === source.eventLinkId)?.diagnostics?.[0];
  const labels = {
    importNeedsStructureAndIdentityReview: "Imported results need course and competitor identity review",
    missingSetup: "Match setup is missing",
    missingStageSetup: "Stage setup is incomplete",
    sourceMatchUnavailable: "Source match is unavailable",
    unresolvedTarget: "Custom target details need review",
    unresolvedTargetOverride: "String target details need review",
    ambiguousTargetReference: "Target references need review",
    unknownTargetReference: "Shot allocations need review",
    ambiguousStageReference: "Stage references need review",
    inconsistentStageReferences: "Stage references need review",
    ambiguousGroupReference: "Firearm group references need review",
    ambiguousOrder: "String order needs review",
    wrongMatchSetup: "Setup belongs to a different match",
  };
  if (issue?.reason === "unsupportedValue" && /\.targetType$/.test(issue.path || "")) return "Custom target details need review";
  return labels[issue?.reason] || "Course setup is incomplete or unsupported";
}

export function tournamentScore(value, family, display) {
  if (typeof value !== "number" || !Number.isFinite(value)) return "-";
  return display || (family === "arc" ? value.toFixed(2) : String(value));
}

export function tournamentPublishedAt(tournament) {
  return tournament?.scoringPolicyVersion === 2 ? tournament.standingsPublishedAt : tournament?.leaderboardRecalculatedAt;
}
